import { objectId } from "@shared/util/object-id"

export type DocumentBackendId = "ember" | "supergrain"

export type DocumentInsertOrigin =
  | "manual"
  | "backend-load"
  | "replication"
  | "server-push"
  | "patch-create"

export interface JsonApiDocument {
  id: string
  type: string
  attributes?: Record<string, unknown>
  meta?: Record<string, unknown>
}

export interface DocumentInsertContext {
  origin: DocumentInsertOrigin
  sourceBackendId?: DocumentBackendId
  transactionId: string
}

export interface DocumentInsertedEvent {
  backendId: DocumentBackendId
  doc: JsonApiDocument
  context: DocumentInsertContext
}

export type DocumentInsertedListener = (event: DocumentInsertedEvent) => void

export function createInsertContext(
  origin: DocumentInsertOrigin = "manual",
  sourceBackendId?: DocumentBackendId,
  transactionId: string = objectId()
): DocumentInsertContext {
  return {
    origin,
    sourceBackendId,
    transactionId,
  }
}
